import { AppStateType } from '../types';

export const selectedFarmUuidSelector = (state: AppStateType) => {
  return state.selectedFarm.uuid;
};
